import React from 'react';
import { Link } from 'react-router-dom';
import {X} from "@untitledui/icons/X";

const BottomBar = ({handleBarRemove}) => {
    return (
        <div className="bottom-bar flex flex-align-center">
            <Link to={'/'} className="announcement-button">Announcement</Link>
            <p className="medium-text">We don’t store your answers. They're used only to generate private, comparison-based insights.</p>
            <button className="remove-bar-button flex flex-align-center" onClick={handleBarRemove}>
                <X color={'#667085'} size={24} />
            </button>
        </div>
    );
}

export default BottomBar;
